import React from 'react'
import { UserOutlined, FormOutlined, HomeOutlined, MessageOutlined, TeamOutlined } from '@ant-design/icons'

export default villageId => {
  return [
    {
      key: 'home',
      label: '首页',
      icon: <HomeOutlined />,
      path: '/'
    },
    {
      key: 'register',
      label: '登记管理',
      icon: <FormOutlined />,
      children: [
        {
          key: 'register-list',
          label: '登记列表',
          path: '/register'
        },
        {
          key: 'healthy-report',
          label: '疫情防控',
          path: '/healthy-report'
        }
      ]
    },
    {
      key: 'user',
      label: '用户管理',
      icon: <TeamOutlined />,
      children: [
        {
          key: 'user-list',
          label: '用户列表',
          path: '/user'
        },
        {
          key: 'secretary-list',
          label: '村庄书记',
          path: '/secretary',
          hide: villageId !== 0
        }
      ]
    },
    {
      key: 'message',
      label: '通知记录',
      icon: <MessageOutlined />,
      children: [
        {
          key: 'message',
          label: '短信发送记录',
          path: '/message/list'
        },
        {
          key: 'voice',
          label: '语音通知记录',
          path: '/message/voice/list'
        }
      ]
    },
    {
      key: 'account',
      label: '系统用户',
      icon: <UserOutlined/>,
      hide: villageId !== 0,
      children: [
        {
          key: 'account-list',
          label: '系统用户列表',
          path: '/account'
        }
      ]
    }
  ]
}
